module.exports = __webpack_public_path__ + "img/1355565323.016db882.jpg";